import React, { type ReactNode } from 'react';

import { ItemWrapper, ResultsWrapper } from './styles';

export interface ResultsProps {
    children: ReactNode;
}

export interface ItemProps {
    children: ReactNode;
}

// TODO: This component requires further work before its
// recommended for wider use.
export function Results({ children }: ResultsProps) {
    return <ResultsWrapper>{children}</ResultsWrapper>;
}

export function Item({ children }: ItemProps) {
    return <ItemWrapper>{children}</ItemWrapper>;
}

Results.Item = Item;
